module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp4-a1ce1585cd21438946a51b813135c8e7.jpg";